<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        class="stock-indicator"
        v-on="on"
        v-bind="attrs"
        :style="{ backgroundColor: indicatorColor }" />
    </template>
    <span>
      {{ $t('entities.items.stockInfo', { stock: available }) }}
    </span>
  </v-tooltip>
</template>

<script>
import { StockAvailabilityThreshold } from '@/constants/stock'

export default {
  name: 'VariantStockIndicatorCircle',
  props: {
    available: { type: Number, default: 0 },
  },
  computed: {
    indicatorColor() {
      if (this.available > StockAvailabilityThreshold.UPPER) return '#4CAF50'
      if (this.available >= StockAvailabilityThreshold.LOWER) return '#FB8C00'
      return '#E53935'
    },
  },
}
</script>

<style scoped>
.stock-indicator {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>
